import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["className"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

// @ts-nocheck
import React, { forwardRef, useContext, useMemo, useEffect } from 'react';
import styled, { keyframes, StyleSheetManager } from 'styled-components';
import ThemeContext from '../utils/ThemeContext';
import { THEME_EMPTY, EUedThemeName } from '../utils/constants';
import { hexToRgbaColor, getThemeData, getStyleSheetTarget, isEmpty } from '../utils';
var EMPTY_OBJECT = {};
var getLoadingKeyframe = function getLoadingKeyframe(props) {
  var circleSize = props.circleSize;
  return keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    0% {\n      stroke-dasharray: 0 ", ";\n      stroke-dashoffset: 0;\n      transform: rotateZ(-90deg);\n    }\n\n    50% {\n      stroke-dasharray: ", " ", ";\n      stroke-dashoffset: 0;\n    }\n\n    99.9% {\n      stroke-dasharray: ", " ", ";\n      stroke-dashoffset: -", ";\n    }\n\n    100% {\n      stroke-dasharray: 0 ", ";\n      stroke-dashoffset: 0;\n      transform: rotateZ(270deg);\n    }\n  "])), circleSize, circleSize, circleSize, circleSize, circleSize, circleSize, circleSize);
};
var Svg = styled.svg(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute !important;\n  top: 50% !important;\n  left: 50% !important;\n  transform: translate(-50%, -50%) !important;\n  width: ", "px !important;\n  height: ", "px !important;\n  #c7n-loading-circle {\n    stroke-width: 4;\n    stroke-dasharray: 0 ", ";\n    fill: ", ";\n    stroke: url(#c7n-ui-loading-circle-gradient);\n    animation: ", " cubic-bezier(0.62, 0.24, 0.59, 0.93) 1.4s\n      infinite;\n    transform-origin: center center;\n  }\n"])), function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.circleSize;
}, function (props) {
  return getThemeData(props, 'spin', 'fillColor') || 'rgba(0,0,0,0)';
}, function (props) {
  return getLoadingKeyframe(props);
});
var getDotRotateKeyframe = function getDotRotateKeyframe() {
  return keyframes(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    0% {\n      transform: rotate(0);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  "])));
};
function getOffset(length, index) {
  var step = 100 / (length - 1);
  return "".concat(step * index, "%");
}
var LoadingCircle = function LoadingCircle(props) {
  var _useContext = useContext(ThemeContext),
    _useContext$resolvedT = _useContext.resolvedTheme,
    resolvedTheme = _useContext$resolvedT === void 0 ? EMPTY_OBJECT : _useContext$resolvedT;
  var _resolvedTheme$spin = resolvedTheme.spin,
    spin = _resolvedTheme$spin === void 0 ? {} : _resolvedTheme$spin;
  var size = spin.size || 50;
  var stopsArray = spin.circleColorGradient || [];
  return /*#__PURE__*/React.createElement(Svg, Object.assign({
    width: size,
    height: size,
    size: size,
    circleSize: (size - 8) * 3.14
  }, props), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c7n-ui-loading-circle-gradient",
    x1: "0",
    x2: "0",
    y1: "0",
    y2: "1"
  }, stopsArray.map(function (s, i) {
    return /*#__PURE__*/React.createElement("stop", {
      key: "".concat(s, "_").concat(i + 1),
      offset: getOffset(stopsArray.length, i),
      stopColor: s
    });
  })), /*#__PURE__*/React.createElement("circle", {
    cx: size / 2,
    cy: size / 2,
    r: size / 2 - 4,
    id: "c7n-loading-circle"
  }));
};
var DotsContainer = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  &.c7n-spin-initial-dot {\n    position: relative;\n    display: inline-block;\n    font-size: 20px;\n    width: 20px;\n    height: 20px;\n    animation: ", " 1s linear infinite;\n    span {\n      width: 9px;\n      height: 9px;\n      border-radius: 100%;\n      background-color: #1890ff;\n      transform: scale(0.75);\n      display: block;\n      position: absolute;\n      transform-origin: 50% 50%;\n      background: ", ";\n      &:first-child {\n        left: 0;\n        top: 0;\n      }\n      &:nth-child(2) {\n        right: 0;\n        top: 0;\n        background: ", ";\n      }\n      &:nth-child(3) {\n        right: 0;\n        bottom: 0;\n        background: ", ";\n      }\n      &:last-child {\n        left: 0;\n        bottom: 0;\n        background: ", ";\n      }\n    }\n  }\n"])), getDotRotateKeyframe(), function (props) {
  return getThemeData(props, 'common', 'primary');
}, function (props) {
  return hexToRgbaColor(getThemeData(props, 'common', 'primary'), 0.8);
}, function (props) {
  return hexToRgbaColor(getThemeData(props, 'common', 'primary'), 0.6);
}, function (props) {
  return hexToRgbaColor(getThemeData(props, 'common', 'primary'), 0.3);
});
var getLoadingDot = function getLoadingDot() {
  var initial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return (
    // eslint-disable-next-line react/display-name
    function (props) {
      var className = props.className,
        rest = _objectWithoutProperties(props, _excluded);
      var _useContext2 = useContext(ThemeContext),
        _useContext2$resolved = _useContext2.resolvedTheme,
        resolvedTheme = _useContext2$resolved === void 0 ? EMPTY_OBJECT : _useContext2$resolved;
      var pClassName = "".concat(className || ' ', " ").concat(initial ? 'c7n-spin-initial-dot' : 'c7n-spin-themed-dot');
      return /*#__PURE__*/React.createElement(DotsContainer, Object.assign({}, rest, {
        className: pClassName,
        data: resolvedTheme
      }), /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null));
    }
  );
};
var c7nRotate = function c7nRotate() {
  return keyframes(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      to {\n        transform: rotate(360deg);\n      }\n  "])));
}; // 还原孔雀蓝原图标效果

var IndictorPointOfThemeTwo = styled.span(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  font-size: 20px;\n  width: 20px;\n  height: 20px;\n  animation: ", " 1s linear infinite;\n  span {\n    width: 9px;\n    height: 9px;\n    border-radius: 100%;\n    background-color: #29bece;\n    transform: scale(0.75);\n    display: block;\n    position: absolute;\n    transform-origin: 50% 50%;\n    /* hzero-ui \u4E2D\u6837\u5F0F\u4F1A\u5BF9\u52A0\u8F7D\u6709\u5F71\u54CD\uFF0C\u8FD9\u91CC\u901A\u8FC7 !important \u5F3A\u884C\u907F\u514D */\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n  span:nth-child(1) {\n    left: 0;\n    top: 0;\n  }\n  span:nth-child(2) {\n    right: 0;\n    top: 0;\n    opacity: 0.4;\n  }\n  span:nth-child(3) {\n    right: 0;\n    bottom: 0;\n    opacity: 0.6;\n  }\n  span:nth-child(4) {\n    left: 0;\n    bottom: 0;\n    opacity: 0.8;\n  }\n"])), c7nRotate);
var indicatorcOfTheme2 = /*#__PURE__*/React.createElement(IndictorPointOfThemeTwo, {
  className: "custom-spin-dot"
}, /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null));
export function useLoadingEl() {
  var _useContext3 = useContext(ThemeContext),
    _useContext3$resolved = _useContext3.resolvedTheme,
    resolvedTheme = _useContext3$resolved === void 0 ? EMPTY_OBJECT : _useContext3$resolved,
    _useContext3$schema = _useContext3.schema,
    schema = _useContext3$schema === void 0 ? 'theme2' : _useContext3$schema;
  var _resolvedTheme$spin2 = resolvedTheme.spin,
    spin = _resolvedTheme$spin2 === void 0 ? {} : _resolvedTheme$spin2;
  var type = spin.type || 'dot'; // dot || circle

  var currentTheme = resolvedTheme.__uedThemeName__ || EUedThemeName.theme2;
  return useMemo(function () {
    var ThemedDots = getLoadingDot();
    var InitialDots = getLoadingDot(true); // 增加 __uedThemeName__ 内部主题名前的逻辑
    // if (schema === "theme4" || schema === "theme5" || schema === THEME_EMPTY) {

    if (currentTheme === EUedThemeName.theme4 || schema === THEME_EMPTY) {
      return undefined; // } else if (schema === "theme2" || schema === "peacock") {
    } else if (currentTheme === EUedThemeName.theme2) {
      return indicatorcOfTheme2;
    }
    var empty = isEmpty(schema, resolvedTheme);
    return !empty ? type === 'circle' ? /*#__PURE__*/React.createElement(LoadingCircle, null) : /*#__PURE__*/React.createElement(ThemedDots, {
      data: resolvedTheme
    }) : /*#__PURE__*/React.createElement(InitialDots, {
      data: resolvedTheme
    });
  }, [currentTheme, schema, type, resolvedTheme]);
}
export function createSpin(Component) {
  // eslint-disable-next-line react/display-name
  var WrapSpin = forwardRef(function (props, ref) {
    var indicator = useLoadingEl();
    var target = useMemo(function () {
      return getStyleSheetTarget('UED_C7N-UI_OVERRIDE_INJECTION_SPIN');
    }, []);
    useEffect(function () {
      return function () {
        return target.childNodes.forEach(function (i) {
          return i.parentElement.removeChild(i);
        });
      };
    }, [target]);
    return /*#__PURE__*/React.createElement(StyleSheetManager, {
      target: target
    }, /*#__PURE__*/React.createElement(Component, Object.assign({}, props, {
      ref: ref,
      indicator: props.indicator || indicator
    })));
  });
  Object.assign(WrapSpin, Component);
  return WrapSpin;
}